import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LayoutsComponent } from '../../layouts/layouts.component';

@Component({
    selector: 'app-gallery-maintenance',
    templateUrl: './gallery-maintenance.component.html',
    styleUrls: ['./gallery-maintenance.component.scss'],
    standalone: true,
    imports: [LayoutsComponent, RouterLink]
})
export class GalleryMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
